module.exports = __webpack_public_path__ + "media/process/Process-Badges-Quality-44c6c8b2.svg";